export default "__VITE_ASSET__4EzIhC67__"